<template>
    <el-tooltip :disabled="disabled" placement="top" effect="dark">
        <div slot="content" style="width: 250px;">{{value}}</div>
        <div class="ellipsis_box" :class="multiline ? 'lineClamp2' : 'ellipsis'" :style="getLineClamp" ref="ellipsis_box">
            {{value}}
        </div>
    </el-tooltip>

</template>
<script>
import {ellipseShowPromise} from '@/utils'
export default {
    props:{
        multiline:{
          type:Boolean,
          default: false
        },
        value: String,
        lineClamp:{
            type:Number,
            default: 2
        }
    },
    name: 'ellipsisTips',
    data() {
        return {
            disabled: true,
            content: ''
        }
    },
    computed: {
      getLineClamp: function () {
          if (this.multiline) {
              return {lineClamp:this.lineClamp,display: '-webkit-box',webkitLineClamp: this.lineClamp, webkitBoxOrient: 'vertical',overflow: 'hidden'}
          }else{
              return {}
          }
        }
    },
    watch:{
      'value': {
          handler(newVal, oldVal) {
              this.$nextTick(()=>{
                  this.setDisabled()
              })
          },
          immediate:true,
          deep: true
      }
    },
    mounted() {
        // this.setDisabled()
    },
    methods:{
        setDisabled(){
            let curEle = this.$refs.ellipsis_box
            ellipseShowPromise(curEle).then(hasEllipsis => {
                if (hasEllipsis) {
                    this.disabled = false
                } else {
                    this.disabled = true
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.lineClamp2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.ellipsis_box{
    width: 100%;
}
</style>
